/** Paridade @setera/session — cookie lido pelo nginx/proxy para header kc-auth no WS. */
export const KC_COOKIE_NAME = "setera_kc_access_token";

export function syncKeycloakCookie(token?: string): void {
  if (typeof document === "undefined") {
    return;
  }

  const secure = window.location.protocol === "https:";
  const base = `path=/; SameSite=Lax${secure ? "; Secure" : ""}`;

  if (!token) {
    document.cookie = `${KC_COOKIE_NAME}=; ${base}; max-age=0`;
    return;
  }

  document.cookie = `${KC_COOKIE_NAME}=${encodeURIComponent(token)}; ${base}; max-age=3600`;
}
